/* eslint-disable react/prop-types */

import React from 'react';
import rctt from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import classNames from 'classnames';
import { overlay } from './styles.scss';

// docs: https://github.com/react-component/tooltip
// docs: http://react-component.github.io/tooltip/
export const RcTooltip = rctt;

export function Tooltip(props) {
  const { overlayClassName, ...otherProps } = props;
  return (
    <RcTooltip
      overlayClassName={classNames(overlay, overlayClassName)}
      {...otherProps}
    />
  );
}
